import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';

import LoginPage from '@/inpatient-patient-pwa/pages/LoginPage';
import IntegrationLoginPage from '@/inpatient-patient-pwa/pages/IntegrationLoginPage';

const baseUrl = process.env.PUBLIC_URL;

/**
 * <PublicRouter> component.
 */
const PublicRouter: React.FunctionComponent = () => (
  <Routes>
    <Route path={`${baseUrl}/login`} element={<LoginPage />} />
    <Route path={`${baseUrl}/integration`} element={<IntegrationLoginPage />} />

    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default PublicRouter;
